define([
    'vue',
    'web/i18n/index',
    'WebCommon/mixin/page',
    'fnjiartist-detail/component/main',
    'css!vendor/font-awesome/css/font-awesome.min.css',
    'css!common/ub-page-reset.css',
    'css!common/ub-page-grid.css',
    'css!fnjiartist-detail/component/main.css'

], function(
    Vue,
    i18n,
    PageMixin,

    MainPage
){

    var app = new Vue({
        mixins: [PageMixin],
        components: {
            MainPage: MainPage
        },
        i18n: i18n
    });
    app.$mount('#app');


});


//////////////////
// WEBPACK FOOTER
// ./fnjiartist-detail/fnjiartist-detail.js
// module id = 146
// module chunks = 7